module.exports = __webpack_public_path__ + "img/dunsters-farm-logo.287b4630.png";